import React from "react";
import { ViewerSettings } from "../../types/settings";

type LanguageCode = ViewerSettings["language"];

function getErrorTitle(language: LanguageCode) {
  switch (language) {
    case "es":
      return "Error al cargar el modelo";
    case "fr":
      return "Erreur de chargement du mod\u00e8le";
    case "de":
      return "Fehler beim Laden des Modells";
    case "zh":
      return "\u52a0\u8f7d\u6a21\u578b\u65f6\u51fa\u9519";
    case "en":
    default:
      return "Error Loading Model";
  }
}

export function ErrorScreen({
  message,
  language = "en",
}: {
  message: string;
  language?: LanguageCode;
}) {
  const title = getErrorTitle(language);
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        margin: 0,
        padding: 0,
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#fafafb",
        flexDirection: "column",
      }}
      data-oid="fp::ruo"
    >
      <div
        style={{
          fontSize: "20px",
          color: "#d32f2f",
          fontWeight: "bold",
          marginBottom: "10px",
        }}
        data-oid="2jql-o1"
      >
        {title}
      </div>
      <div
        style={{
          fontSize: "14px",
          color: "#666",
          maxWidth: "500px",
          textAlign: "center",
          whiteSpace: "pre-wrap",
        }}
        data-oid="5weu0l_"
      >
        {message}
      </div>
    </div>
  );
}
